import {
  ButtonBase,
  Card,
  CardContent,
  Collapse,
  Divider,
  Typography,
} from '@material-ui/core'
import { InfoOutlined } from '@material-ui/icons'
import { styled } from '@material-ui/styles'
import { memo, useState } from 'react'

import CustomControl from '@/components/map/custom-control'

import { useStyles } from './styles'

const Button = styled(ButtonBase)(({ theme }: any) => ({
  backgroundColor: '#fff',
  padding: '0.8rem',
  color: theme.palette.secondary.main,
  '& > svg': {
    width: 25,
    height: 25,
  },
}))

interface InfoButtonProps {
  title?: string
  message?: string
}

const InfoButton = ({ title, message }: InfoButtonProps) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(false)

  const handleExpandClick = () => {
    setExpanded(!expanded)
  }

  return (
    <CustomControl
      data-testid='info-control'
      style={{
        overflow: 'hidden',
        marginBottom: '4rem',
        marginRight: '10rem',
      }}
      position='bottomleft'
    >
      <Card className={classes.root}>
        <Button
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label='show more'
        >
          <InfoOutlined />
        </Button>
        <Collapse in={expanded} unmountOnExit>
          <CardContent>
            <Typography>{title}</Typography>
            <Divider />
            <Typography>{message}</Typography>
          </CardContent>
        </Collapse>
      </Card>
    </CustomControl>
  )
}

export default memo(InfoButton)
